export default "__VITE_ASSET__dN5hfraR__"